//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */
export default {
  name: "ActivePricingPackageItemComponent",
  props: {
    // 背景颜色
    backgroundColor: {
      type: String,
      required: true,
    },
    // 类型名称
    type: {
      type: String,
      required: true,
    },
    // 价格
    price: {
      type: Number,
      required: true,
    },
    display: {
      type: String,
      default: "",
    },
    // 描述信息
    des: {
      type: String,
      required: true,
    },
    // 是否处于激活状态
    active: {
      type: Boolean,
      default: false,
    },
    // 是否有 most popular 标识
    popular: {
      type: Boolean,
      default: true,
    },
    // 是否全部都可点击
    clickAble: {
      type: Boolean,
      default: false,
    },
    // 当前激活状态所显示文字
    yourPlanText: {
      type: String,
      default() {
        return this.$t("planUpgradePage.yourPlan");
      },
    },
  },
  computed: {
    /**
     * 计算css样式
     * @returns {{}}
     */
    itemStyle() {
      let style = {};
      style["border-color"] = this.backgroundColor;
      if (this.active && !this.clickAble) {
        style.color = this.backgroundColor;
        style.background = "white";
      } else {
        style.background = this.backgroundColor;
      }
      return style;
    },
    /**
     * 计算价格 价格为0 不显示
     */
    priceText() {
      if (this.price === 0) return "";
      return `${this.display}`;
    },
    des1() {
      // ✓ ✗
      const desArr = this.des.split("\n");
      let result = [];
      desArr.forEach((row) => {
        const iconIndex = [...row].findIndex((r) => r === "✓" || r === "✗");
        console.log("row", iconIndex);
        result.push({
          icon: row.substr(0, iconIndex + 1).trim(),
          // eslint-disable-next-line
          text: row
            .substr(iconIndex + 1)
            .replace(/  /g, "")
            .trim(), // 玄学过滤 千万不要动，否则pt语言会有问题
          forbid: [...row].findIndex((r) => r === "✗") !== -1,
        });
      });
      return result;
    },
  },
  methods: {
    /**
     * 条目点击事件
     */
    itemClick() {
      this.$emit("click");
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/active/pricing_package/Item.vue